export const getIntersectingIcon = (isIntersectingWithViewport: boolean): string =>
  isIntersectingWithViewport ? "👁️" : "🚫"
